export default __webpack_public_path__ + "static/media/search.16512b92.svg";